import { Fragment, useEffect, useState } from "react";
import "./App.css";
import Home from "./Components/Home";
import Footer from "./Components/Layouts/Footer";
import Header from "./Components/Layouts/Header";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ProductDetail from "./Components/products/ProductDetail";
import Login from "./Components/user/Login";
import Register from "./Components/user/Register";
import { useDispatch } from "react-redux";
import { loadUser } from "./actions/userActions";
import PrivateRoute from "./Components/route/PrivateRoute";
import Profile from "./Components/user/Profile";
import UpdateProfile from "./Components/user/UpdateProfile";
import UpdatePassword from "./Components/user/UpdatePassword";
import ForgotPassword from "./Components/user/ForgotPassword";
import NewPassword from "./Components/user/NewPassword";
import Cart from "./Components/cart/Cart";
import Shipping from "./Components/cart/Shipping";
import ConfirmOrder from "./Components/cart/ConfirmOrder";
//Payment

import Payment from "./Components/cart/Payment";
import OrderSuccess from "./Components/cart/OrderSuccess";
import ListOrders from "./Components/order/ListOrders";
import OrderDetails from "./Components/order/OrderDetails";
import Dashboard from "./Components/admin/Dashboard";
import ProductsList from "./Components/admin/ProductsList";
import NewProduct from "./Components/admin/NewProduct";
import UpdateProduct from "./Components/admin/UpdateProduct";
import OrdersList from "./Components/admin/OrdersList";
import ProcessOrder from "./Components/admin/ProcessOrder";
import UsersList from "./Components/admin/UsersList";
import UpdateUser from "./Components/admin/UpdateUser";
import ProductReviews from "./Components/admin/ProductReviews";

function App() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(loadUser());
  }, [dispatch]);
  return (
    <Fragment>
      <Router>
        <Header />
        <Routes>
          <Route path="/" exact element={<Home />} />
          <Route path="/login" exact element={<Login />} />
          <Route path="/register" exact element={<Register />} />
          <Route exact path="/me" element={<PrivateRoute />}>
            <Route exact path="/me" element={<Profile />} />
          </Route>
          <Route exact path="/me/update" element={<PrivateRoute />}>
            <Route exact path="/me/update" element={<UpdateProfile />} />
          </Route>
          <Route exact path="/password/update" element={<PrivateRoute />}>
            <Route exact path="/password/update" element={<UpdatePassword />} />
          </Route>
          <Route exact path="/password/forgot" element={<ForgotPassword />} />
          <Route
            exact
            path="/password/reset/:token"
            element={<NewPassword />}
          />

          <Route path="/search/:keyword" element={<Home />} />
          <Route path="/cart" element={<Cart />} />

          <Route exact path="/product/:id" element={<PrivateRoute />}>
            <Route path="/product/:id" exact element={<ProductDetail />} />
          </Route>
          <Route exact path="/shipping" element={<PrivateRoute />}>
            <Route path="/shipping" exact element={<Shipping />} />
          </Route>
          <Route exact path="/order/confirm" element={<PrivateRoute />}>
            <Route path="/order/confirm" exact element={<ConfirmOrder />} />
          </Route>
          <Route exact path="/payment" element={<PrivateRoute />}>
            <Route path="/payment" exact element={<Payment />} />
          </Route>
          <Route exact path="/success" element={<PrivateRoute />}>
            <Route path="/success" exact element={<OrderSuccess />} />
          </Route>
          <Route exact path="/orders/me" element={<PrivateRoute />}>
            <Route path="/orders/me" exact element={<ListOrders />} />
          </Route>
          <Route exact path="/order/:id" element={<PrivateRoute />}>
            <Route path="/order/:id" exact element={<OrderDetails />} />
          </Route>
          <Route exact path="/dashboard" element={<PrivateRoute />}>
            <Route path="/dashboard" exact element={<Dashboard />} />
          </Route>
          <Route exact path="/admin/products" element={<PrivateRoute />}>
            <Route path="/admin/products" exact element={<ProductsList />} />
          </Route>
          <Route exact path="/admin/product" element={<PrivateRoute />}>
            <Route path="/admin/product" exact element={<NewProduct />} />
          </Route>
          <Route exact path="/admin/orders" element={<PrivateRoute />}>
            <Route path="/admin/orders" exact element={<OrdersList />} />
          </Route>
          <Route exact path="/admin/order/:id" element={<PrivateRoute />}>
            <Route path="/admin/order/:id" exact element={<ProcessOrder />} />
          </Route>
          <Route exact path="/admin/users" element={<PrivateRoute />}>
            <Route path="/admin/users" exact element={<UsersList />} />
          </Route>
          <Route exact path="/admin/user/:id" element={<PrivateRoute />}>
            <Route path="/admin/user/:id" exact element={<UpdateUser />} />
          </Route>
          <Route exact path="/admin/reviews" element={<PrivateRoute />}>
            <Route path="/admin/reviews" exact element={<ProductReviews />} />
          </Route>
          <Route exact path="/admin/product/:id" element={<PrivateRoute />}>
            <Route
              path="/admin/product/:id"
              exact
              element={<UpdateProduct />}
            />
          </Route>
        </Routes>
        <Footer />
      </Router>
    </Fragment>
  );
}

export default App;
